<template>
    <div>
        <validation-observer #default="{ invalid }" ref="observer">
            <span class="display-none">{{ invalid }}</span>
            <b-form ref="formular">
                <div class="white-box mt-3">
                    <div class="data-group">
                        <M3FormTitle title="Informații generale" :checked="completed"></M3FormTitle>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            name="denumire companie"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                class="custom-responsive"
                                label-cols-sm="2"
                                label-cols-lg="2"
                                content-cols-sm
                                content-cols-lg="10"
                                label="Denumire companie"
                            >
                                <b-form-input
                                    id="name"
                                    v-model="form.name"
                                    type="text"
                                    name="message"
                                    :state="errors.length > 0 ? false : null"
                                    :readonly="completed"
                                    @input="$emit('unsavedChanges', !!form.name)"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            name="formă juridică"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                class="custom-responsive"
                                label-cols-sm="2"
                                label-cols-lg="2"
                                content-cols-sm
                                content-cols-lg="10"
                                label="Formă juridică"
                            >
                                <div class="inline-inputs select-input">
                                    <b-form-select
                                        v-model="form.business_type"
                                        :options="formTypes"
                                        :state="errors.length > 0 ? false : null"
                                        :disabled="completed"
                                        :class="completed ?'disabled-select':''"
                                        @input="$emit('unsavedChanges', !!form.business_type); businessTypeName(form.business_type)"
                                    >
                                    </b-form-select>
                                    <b-form-input
                                        v-model="businessType"
                                        type="text"
                                        readonly
                                    ></b-form-input>
                                </div>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>

                        </validation-provider>
                        <div class="flex flex-end responsive-redefine">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="first-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    class="custom-responsive"
                                    label-cols-sm="3"
                                    label-cols-lg="3"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="Statut TVA"
                                >
                                    <div class="inline-inputs select-input imm">
                                        <b-form-select
                                            v-model="form.vat_status"
                                            :options="vatStatuses"
                                            :state="errors.length > 0 ? false : null"
                                            :disabled="completed"
                                            :class="completed ?'disabled-select':''"
                                        >
                                        </b-form-select>
                                    </div>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="second-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    class="custom-responsive"
                                    label-cols-sm="4"
                                    label-cols-lg="4"
                                    content-cols-sm
                                    content-cols-lg="8"
                                    label="Tipul de IMM"
                                >
                                    <div class="inline-inputs select-input imm">
                                        <b-form-select
                                            v-model="form.imm_type"
                                            :options="immTypes"
                                            :state="errors.length > 0 ? false : null"
                                            :disabled="completed"
                                            :class="completed ?'disabled-select':''"
                                        >
                                        </b-form-select>
                                    </div>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                        </div>
                        <div class="flex flex-end responsive-redefine">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="first-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    class="custom-responsive"
                                    label-cols-sm="4"
                                    label-cols-lg="3"
                                    content-cols-sm
                                    content-cols-lg="9"
                                    label="CUI/CIF"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.business_id"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="true"
                                        @input="$emit('unsavedChanges', !!form.business_id)"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                class="second-input"
                            >
                                <b-form-group
                                    id="fieldset-horizontal"
                                    class="custom-responsive"
                                    label-cols-lg="4"
                                    content-cols-lg="8"
                                    label="Nr. Registrul Comerțului"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="form.reg_no"
                                        type="text"
                                        name="message"
                                        :state="errors.length > 0 ? false : null"
                                        :readonly="completed"
                                        @input="$emit('unsavedChanges', !!form.reg_no)"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                        </div>
                        <validation-provider
                            #default="{ errors }"
                            rules="required|digits:4"
                            name="cod CAEN"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                class="custom-responsive"
                                label-cols-lg="2"
                                content-cols-lg="10"
                                label="Cod CAEN principal"
                            >
                                <div class="inline-inputs">
                                    <div class="has-icon">
                                        <b-form-input
                                            id="name"
                                            v-model="form.main_caen"
                                            type="text"
                                            name="business_type"
                                            :state="errors.length > 0 ? false : null"
                                            :readonly="completed"
                                            @input="$emit('unsavedChanges', !!form.main_caen)"
                                            @keyup="getCaenName(form.main_caen)"
                                        ></b-form-input>
                                        <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                                    </div>
                                    <b-form-input
                                        v-model="caenName"
                                        type="text"
                                        readonly
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </b-form-group>
                        </validation-provider>
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                            name="data înființării"
                        >
                            <b-form-group
                                id="fieldset-horizontal"
                                class="custom-responsive"
                                label-cols-sm="2"
                                label-cols-lg="2"
                                content-cols-sm
                                content-cols-lg="10"
                                label="Data înființării"
                            >
                                <b-form-datepicker
                                    id="dataInfiintari"
                                    v-model="form.register_date"
                                    class="w-100"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    locale="ro"
                                    :max="max"
                                    placeholder="Selectează o dată"
                                    :readonly="completed"
                                    :class="{ 'completed': completed }"
                                ></b-form-datepicker>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </b-form-group>

                        </validation-provider>
                        <M3Warn
                            type="blue"
                            :text="'<strong>ATENȚIE! Încadrarea în categoria intreprindere ' + form.imm_type + ' </strong>s-a realizat în baza informațiilor cu privire la numărul de angajați și cifra de afaceri. Dacă informațiile nu sunt corecte sau firma face parte din categoria întreprinderilor legate sau partenere, vă rugăm să selectați manual tipul de IMM. Vă mulțumim!'"
                        ></M3Warn>
                        <M3Warn
                            type="yellow"
                            :text="'<strong>ATENȚIE! În cazul în care reprezentați o firma legată sau parteneră,</strong> vă rugăm să analizați cu atenție prevederile legii Nr. 346 din 14 iulie 2004 privind stimularea înfiinţării şi dezvoltării întreprinderilor mici şi mijlocii, în special Art. 6 (alin) (6) Datele, inclusiv numărul mediu anual de salariaţi, ale unei întreprinderi partenere sau legate cu o altă întreprindere se vor stabili pe baza situaţiilor financiare anuale şi a altor date ale întreprinderii ori, dacă există, pe baza situaţiilor financiare anuale consolidate în care întreprinderea este inclusă, care se vor cumula cu datele oricărei întreprinderi partenere a întreprinderii în cauză, situată imediat în amonte sau în aval de aceasta, proporţional cu procentul de participare la capital ori cu procentul drepturilor de vot (cel mai ridicat dintre aceste procente)\n'"
                            class="mb-4"
                        ></M3Warn>
                        <hr class="mt-5">
                        <b-form-checkbox
                            v-model="completed"
                            switch
                            size="lg"
                            class="switch-box"
                            @change="completeForm()"
                        >Informațiile sunt complete și corecte</b-form-checkbox>
                    </div>
                    <a href="https://termene.ro/" target="_blank">
                        <img src="@/assets/images/M3/M3Sketch/termenesmall.png" class="termene-icon">
                    </a>
                </div>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
    import { BForm, BFormInput, BFormGroup, BButton, BFormCheckbox, BFormSelect, BFormDatepicker } from 'bootstrap-vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    require('@/helpers/validations/validations')
    import M3FormTitle from '../M3FormTitle'
    import axios from '@/helpers/axios';
    import api from '@/helpers/api';
    import caen from '../../caen'

    export default {
        components: {
            BForm,
            BFormInput,
            BFormGroup,
            BButton,
            BFormCheckbox,
            BFormDatepicker,
            BFormSelect,
            M3FormTitle,
            M3Warn,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            data: null,
            activeCompany: null,
            spendings: null,
            typeChanged: null
        },
        data() {

            return {
                form: {
                    name: '',
                    business_type: '',
                    vat_status: '',
                    imm_type: '',
                    business_id: '',
                    reg_no: '',
                    main_caen: '',
                    general_information_saved: true,
                    register_date: '',
                },
                max: new Date(),
                formTypes: [
                    { value: 'SRL', text: 'SRL' },
                    { value: 'SRL-D', text: 'SRL-D' },
                    { value: 'SA', text: 'SA' },
                ],
                immTypes: [
                    { value: 'micro', text: 'ÎNTREPRINDERE MICRO' },
                    { value: 'mică', text: 'ÎNTREPRINDERE MICĂ' },
                    { value: 'mijlocie', text: 'ÎNTREPRINDERE MIJLOCIE' },
                ],
                vatStatuses: [
                    { value: 'PLATITOR', text: 'PLĂTITOR' },
                    { value: 'NEPLATITOR', text: 'NEPLĂTITOR' },
                ],
                completed: false,
                businessType: '',
                immType: '',
                caenName: '',
                caens: caen,
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            typeChanged: {
                handler: function() {
                    this.completed = false
                    this.form.imm_type = this.typeChanged
                    this.completed = true
                },
                deep: true,
            },
            checks: {
                handler: function() {
                    this.completed = this.checks.companiaMeaInformatiiGenerale;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            data(newValue, oldValue){
                if(newValue !== oldValue){
                    this.form = this.data
                    this.getCaenName(this.form.main_caen)
                    this.businessTypeName(this.form.business_type)
                    if(this.data.name && (this.data.name.includes('SRL') || this.data.name.includes('S.R.L.') || this.data.name.includes('S.R.L')) && !this.data.name.replace('.', '').toLowerCase().replace(' ', '').includes('srl-d')){
                        this.form.business_type = 'SRL'
                    } else if(this.data.name && this.data.name.replace('.', '').toLowerCase().replace(' ', '').includes('srl-d')){
                        this.form.business_type = 'SRL-D'
                    } else if(this.data.name && (this.data.name.includes('SA') || this.data.name.includes('S.A.') || this.data.name.includes('S.A'))){
                        this.form.business_type = 'SA'
                    }
                }
            }
        },
        mounted() {
            if(this.data !== null) {
                this.form = this.data
                this.getCaenName(this.form.main_caen)
                this.businessTypeName(this.form.business_type)
                if(this.data.name && (this.data.name.includes('SRL') || this.data.name.includes('S.R.L.') || this.data.name.includes('S.R.L')) && !this.data.name.replace('.', '').toLowerCase().replace(' ', '').includes('srl-d')){
                    this.form.business_type = 'SRL'
                } else if(this.data.name && this.data.name.replace('.', '').toLowerCase().replace(' ', '').includes('srl-d')){
                    this.form.business_type = 'SRL-D'
                } else if(this.data.name && (this.data.name.includes('SA') || this.data.name.includes('S.A.') || this.data.name.includes('S.A'))){
                    this.form.business_type = 'SA'
                }
            }
        },
        methods: {
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(this.completed){
                            this.form.general_information_saved = true
                            if(this.allData.vat_status != this.form.vat_status) {
                                this.showAcquisitionsWarning()
                            }
                            this.$store.dispatch('m3Sketch/saveAllDataPart', this.form)
                                .then((response) => {
                                    this.$emit('immUpChanged', this.form.imm_type)
                                    this.$store.dispatch("m3Sketch/initializeIndicators");
                                    this.$toast.success(response.data.message)
                                }).catch((xhr) => {
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    this.$toast.error(xhr.response.data.message);
                                });
                        }
                    }
                    if(this.checks.companiaMeaInformatiiGenerale !== this.completed)
                        this.$store.dispatch('checks/updateChecks', {name: 'companiaMeaInformatiiGenerale', value: this.completed})
                })

            },
            businessTypeName(event) {
                if(event) {
                    if (event.toUpperCase() === 'SRL') {
                        this.businessType = 'SOCIETATE CU RĂSPUNDERE LIMITATĂ'
                    } else if (event.toUpperCase() === 'SRL-D') {
                        this.businessType = 'SOCIETATE CU RĂSPUNDERE LIMITATĂ - DEBUTANT'
                    } else if (event.toUpperCase() === 'SA') {
                        this.businessType = 'SOCIETATE PE ACȚIUNI'
                    } else {
                        this.businessType = ''
                    }
                }
            },
            getCaenName(event) {
                if (this.caens[event]) {
                    this.caenName = this.caens[event]
                } else{
                    this.caenName = ''
                }
            },
            showAcquisitionsWarning() {
                let haveAcquisitions = false;

                this.spendings.map(function(category) {
                    category.subcategories.map(function(subcategory) {
                        if(subcategory.acquisitions.length > 0) {
                            haveAcquisitions = true
                            return;
                        }
                    });
                    if(haveAcquisitions) return;
                });

                if(haveAcquisitions) {
                    this.$swal({
                        heightAuto: false,
                        title: 'Te rugăm să verifici valoarea maximă eligibilă a cheltuielilor cât și să editezi toate achizițiile proiectului.',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Editează achizițiile',
                        cancelButtonText: 'Închide',
                        showDenyButton: false
                    }).then((result) => {
                        axios.get(api.API_ENDPOINTS.notify)
                        if (result.isConfirmed) {
                            this.$router.push({name: 'AchizitiiCheltuieli'});
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped>
.text-danger{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    white-space: pre;
    top: 0;
    bottom: 0;
    margin: auto;
    align-items: center;
    right: 20px;
}
.flex{
    display: flex;
}
.flex-end{
    justify-content: flex-end;
}
.first-input{
    width: 47%;
}
.second-input{
    width: 48%;
}
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 90%;
}
.switch-box{
    text-align: right;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.form-group >>> legend{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
}
.form-group >>> input{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
}
.select-input >>> select{
    font-size: 14px;
    font-weight: 700;
    color: #767a95;
    background: #e9ecef;
    border-radius: 2px;
    max-width: 170px;
    margin-right: 10px;
    margin-bottom: 0;
}
.imm > select {
    min-width: 100%;
    margin-right: 0;
}
.select-input >>> .disabled-select{
    background: #a1fff1;
    opacity: 1;
}
.form-group >>> input:read-only{
    background: #a1fff1;
}
.form-group >>> .form-row{
    align-items: center;
}
.inline-inputs{
    display: flex;
}
.inline-inputs input:first-child, .inline-inputs div:first-child{
    width: 25%;
    margin-right: 10px;
}
.inline-inputs div:first-child input{
    width: 100%;
}
.has-icon{
    position: relative;
}
.has-icon img{
    position: absolute;
    top: 10px;
    right: 20px;
    opacity: 0.3;
}
.termene-icon{
    position: absolute;
    bottom: 15px;
    left: 20px;
}
.b-form-datepicker{
    color: #767a95;
    background: #e9ecef;
    font-size: 14px;
    font-weight: 700;
    padding: 0;
    max-height: 33px;
    border-radius: 2px;
}
.completed{
    background: #d1f5ea!important;
    color:#b2b6be!important;
    pointer-events: none;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px;
    }
}
</style>
